export const PROJECTIONS = [
  "Transparency",
  "Max. projection",
  "Max. RGB average",
  "Iso-surface",
];
export const CAMERA_ROTATE_SPEED = -0.003;
export const SCROLL_ZOOM_SPEED = 0.1;
export const TOUCH_SPEED = -0.01;
export const PAN_SPEED = 0.01;
export const OBJECT_ROTATE_SPEED = 0.01;
